import {Component, ViewChild} from '@angular/core';
import {Config, Nav, Platform, MenuController, Events, NavController} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
import { EbsWebServiceGlobals } from "../services/ebsWebServiceGlobals";
import { EbsWebService } from "../services/ebsWebService";
import { EbsComponentService } from "../services/ebsComponentService";
import { LoginPage } from '../pages/login/login';
import { Storage } from '@ionic/storage';
import {timeout} from "rxjs/operator/timeout";
declare var $;
@Component({
  templateUrl: 'app.html'
})



export class MyApp {
  @ViewChild(Nav) nav: Nav;


  rootPage: any;
  loginPage: boolean = true;
  loginUrl: any = "";
  webServiceResponse:any = "";
  showErrorPage = false;
  pages: Array<{title: string, ActionType:any, component: any, actionURL: string, actionParams: string, icon: string}>;
  loginObject:any = "";


  constructor(public platform: Platform,
              config:Config,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals,
    private _ebsWebService: EbsWebService,
    private _ebsComponentService:EbsComponentService,
    private menuCtrl: MenuController,
    public events: Events,
    private storage: Storage) {



    config.set('mode', 'ios');

    this.pages = [];

    this.initializeApp();
    this.buildAppFromWebService();

    events.subscribe('setting:LoginPage', () => {
      this.loginPage = false;
      this.menuCtrl.enable(true);
      this._ebsWebServiceGlobals.setShowLoginScreen(false);
      this.buildAppFromWebService();
      this.rootPage = HomePage;
    });
  }

   buildAppFromWebService(){

    this._ebsWebService.postData(this._ebsWebServiceGlobals.getEbsWebServiceMainNavigationURL(),null).subscribe(res=>{
      this.webServiceResponse = res;
      this.loadLoginScreenSettingFromWebService(res);
      this.loadIconsIfChangedFromWebserviceToLocalStorage(res);
      this.loginObject = res.LoginData;
      this.setRootPage();
      this._ebsWebService.setBrowserTabTitle(res.MainTitle);
      this.loadMenuFromWebService(res);
      setTimeout(() => { //Check after 5 Seconds if icons loaded correct
        this.checkIfIconsNotLoadedCorrect(res);
      },5000);
    });

    //Show Error Page if no Response after some Time
    setTimeout(() => {
      this.showErrorPage = true;
    }, 5000);
  }

  loadLoginScreenSettingFromWebService(res) {
    if(res.LoginUrl == null || res.LoginUrl == "" || typeof res.LoginUrl == "undefined") {
      this._ebsWebServiceGlobals.setShowLoginScreen(false);
    } else {
      this._ebsWebServiceGlobals.setLoginUrl(res.LoginUrl);
      this._ebsWebServiceGlobals.setShowLoginScreen(true);
    }
  }

  setRootPage() {
    if(this._ebsWebServiceGlobals.getShowLoginScreen()) {
      this.menuCtrl.enable(false);
      this.loginPage = true;
      this.nav.setRoot(LoginPage, {loginObject: this.loginObject});
    } else {
      this.menuCtrl.enable(true);
      this.loginPage = false;
      this.rootPage = HomePage;
    }
  }

  loadIconsIfChangedFromWebserviceToLocalStorage(res, brokenIcons = false) {
    if (typeof res.CurrentIconDataHash!= "undefined" && res.CurrentIconDataHash != null) {
      if (res.CurrentIconDataHash !=  this._ebsWebService.getIconsLastChangeDate() ||  brokenIcons) {
        this._ebsWebService.setIconsLastChangeDate(res.CurrentIconDataHash);
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(res.ActionGetIconDataPostParameters);
        this._ebsWebService.postData(res.ActionGetIconData,postPayloadObject).subscribe(res => {
          this.loadIconsFromWebService(res);
        });
      }
    }

  }

  async checkIfIconsNotLoadedCorrect(res) {
    if (typeof res != "undefined" && res.ListItemNavigation != "undefined" && res != null && res.ListItemNavigation != null) {
      let firstItemFileName = res.ListItemNavigation[0].Icon;
      let base64Image = await Promise.resolve(this.storage.get(firstItemFileName));
      if (base64Image == null || typeof base64Image == "undefined" || base64Image == "") {
        this.loadIconsIfChangedFromWebserviceToLocalStorage(res,true);
      }
    }
  }

  loadIconsFromWebService(res){
    if(typeof res.ListItemIcon != "undefined" && res.ListItemIcon != null && res.ListItemIcon.length) {
      this._ebsWebService.setIconsInStorage(res.ListItemIcon);
    }
  }


  loadMenuFromWebService(res) {
    if (typeof res.ListItemNavigation != "undefined" && res.ListItemNavigation != null) {
      res.ListItemNavigation.forEach(element => {
        let component = this._ebsComponentService.getComponentByAction(element.ViewTypeAction);
        this.pages.push({title: element.Caption, ActionType: element.ActionType, component: component, actionURL: element.Action, icon: element.Icon, actionParams: element.PostParameters});
      });
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    let navParams = {
      title: page.title,
      actionURL: page.actionURL,
      postParams: page.actionParams
    };
    this._ebsComponentService.navigationController(page,navParams,this.nav,page.component);
  }

  openDebugUrlWithPostParams(url, paramsJson) {
    var f = $("<form target='_blank' method='POST' style='display:none;'></form>").attr({
      action: url
    }).appendTo(document.body);
    let params = JSON.parse(paramsJson);
    for (var i in params) {
      if (params.hasOwnProperty(i)) {
        $('<input type="hidden" />').attr({
          name: i,
          value: params[i]
        }).appendTo(f);
      }
    }
    f.submit();
    f.remove();
  }




}



// WEBPACK FOOTER //
// ./src/app/app.component.ts